import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '../main/main.component';
import { ProfessionalsComponent } from './pages/professionals.component';
import { ConferencesComponent } from './contents/conferences/conferences.component';
import { HealthComponent } from './contents/health/health.component';

const routes: Routes = [
  { 
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'profesionales',
        component: ProfessionalsComponent,
        children: [
          {
            path: 'conferencias',
            component: ConferencesComponent
          },
          {
            path: 'salud-nutricion',
            component: HealthComponent
          }
        ]
      }
    ]
  },
];

export const ProfessionalsRoutes = RouterModule.forChild(routes);
